// Who PostHog should never count (fix-list #16).
//
// - Staff accounts (admin / demo) browse every tenant all day; their clicks
//   would swamp real customer usage, so they are opted out of capture.
// - Local development hosts never send at all, whatever key is configured,
//   so a dev with a real key in .env.local can't pollute the production
//   project (400398).
//
// NOTE: the session-replay PR (#1272) carries its own STAFF_EMAILS list in
// src/posthog.js. Once both merge, point that one at isStaffEmail.

export const STAFF_EMAILS = ['admin@timbercloud.com', 'demo@timbercloud.com'];

export function isStaffEmail(email) {
  if (typeof email !== 'string') return false;
  return STAFF_EMAILS.includes(email.trim().toLowerCase());
}

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '[::1]', '::1'];

export function isLocalDevHost(hostname) {
  if (typeof hostname !== 'string' || !hostname) return false;
  const h = hostname.toLowerCase();
  return (
    LOCAL_HOSTS.includes(h) || h.endsWith('.localhost') || h.endsWith('.test')
  );
}

// PostHogIdentity's decision: identify a signed-in user only when they are a
// real (non-staff) user. Staff are opted out instead.
export function shouldIdentify(user) {
  return !!user?.id && !isStaffEmail(user.email);
}
